module.exports = __webpack_public_path__ + "static/media/message.8552dfd9.svg";